// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { HSStaticMethods } from "preline/preline"
import "@37signals/lexxy"
import * as Lexxy from "@37signals/lexxy"
// Initialize Preline components
document.addEventListener("DOMContentLoaded", function() {
  HSStaticMethods.autoInit();
});

// Re-initialize Preline on Turbo navigation
document.addEventListener("turbo:load", function() {
  HSStaticMethods.autoInit();
});

// Configure Lexxy profiles
Lexxy.configure({
  tc_limited: {
    attachments: false,
    headings: []
   }
});
